import { Typography, Chip } from "@mui/material";

// Renders a comment body, turning @[Name](userId) mention tokens into chips.
const MENTION_SPLIT_REGEX = /(@\[[^\]]+\]\([a-f0-9]{24}\))/g;
const MENTION_PARSE_REGEX = /^@\[([^\]]+)\]\(([a-f0-9]{24})\)$/;

const MentionText = ({ body }) => {
  const parts = String(body || '').split(MENTION_SPLIT_REGEX);

  return (
    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }} component="div">
      {parts.map((part, index) => {
        const match = part.match(MENTION_PARSE_REGEX);
        if (match) {
          return (
            <Chip
              key={index}
              label={`@${match[1]}`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ height: 20, fontSize: '0.75rem', mx: 0.25 }}
            />
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </Typography>
  );
};

export default MentionText;
